import React, {useEffect, useState} from "react";
import OtpInput from "./otpInputField";
import StorefrontTitle from "../../shared/storefront-title.component";
import Translations from "../../../services/translation.service";
import SpinnerTimeLoader from "../timeLoading";
import useCountdownSecondsTimer from "../../shared/hooks/use-countdown-seconds-timer";

let subscriptions = [];
const OtpScreen = ({
  onSubmit= () => {},
  isFormValid = false,
  otpError,
  otpErrorCode = null,
  title,
  desc,
  translationNeeded = true,
  loading = false,
  otpLength = 6,
  timer,
  requestNewOtp = () => {},
  handleOtpForm = () => {},
  handleOtpError = () => {}
  }) => {
    let prefix = "stm_otp_";
    const [translationKeys, setTranslationsKeys] = useState(Translations.keys ? Translations.keys : {})
    const { formattedTimer, remainingSeconds } = useCountdownSecondsTimer(timer);

    useEffect(()=>{
        subscriptions.push(
            Translations.getKeysObsrv().subscribe(data => {
                setTranslationsKeys(data);
            })
        )

        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        }
    },[])

  return (
    <div className="otp-screen-wrapper">
      <StorefrontTitle
        title={translationNeeded ? translationKeys[title] : title}
        desc={translationNeeded ? translationKeys[desc] : desc}
      />
      {loading ? <SpinnerTimeLoader /> :
      <>
        <OtpInput otpError={otpError} handleOtpForm={handleOtpForm} handleOtpError={handleOtpError} OTPlength={otpLength}/>
        {otpError && <p className="error">{translationKeys[prefix + "error" + otpErrorCode] || translationKeys[prefix + "error"]}</p>}
        <div className="send-message">
          <p>{translationKeys[prefix + "received"]}</p>
          {timer ? 
            <>
              {remainingSeconds > 1 ?
              <span>{formattedTimer}{formattedTimer ? translationKeys[prefix + "seconds"] || "s" : ""}</span> :
              <span onClick={requestNewOtp}>{translationKeys[prefix + "send_again"]}</span>}
            </> : 
            <span onClick={requestNewOtp}>{translationKeys[prefix + "send_again"]}</span>
          }
        </div>
        <button onClick={onSubmit} disabled={!isFormValid}>{translationKeys[prefix + "continue"]}</button>
      </>}
    </div>
  );
};

export default OtpScreen;
